// extracted by mini-css-extract-plugin
module.exports = {"container":"EditableTagGroup_container__1kHR4","input":"EditableTagGroup_input__3PFNL","plusTag":"EditableTagGroup_plusTag__qY-JG"};